var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSushi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.495 19.496c1.88-2.882-1.629-8.896-8.144-13.156C15.96 1.83 9.196.702 7.19 3.584L1.427 11.98l.032.02c-1.795 3.046 1.824 8.697 8.11 13.134 6.328 4.467 13.024 5.616 15.1 2.84l.061.042 5.765-8.52zm-14.66-3.383c5.89 4.135 12.029 5.388 13.783 2.882 1.629-2.506-1.88-7.768-7.768-11.903C15.96 2.957 9.82 1.704 8.067 4.21c-1.754 2.506 1.754 7.769 7.768 11.903zm1.379-2.255c3.007 2.005 6.014 2.631 6.89 1.378.878-1.253-.876-3.884-3.758-5.889-3.007-2.004-6.014-2.63-6.891-1.378-.877 1.252.877 3.883 3.759 5.888z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/SUSHI.0aca0f8c5c4adeaac1707a3310a335e1.svg";
export { ForwardRef as ReactComponent };